import styled from "@emotion/styled";
import { Col, Row } from "antd";
import { SellerReportPeriod } from "services/interface/sellerReport.interface";
import { numberFormatInt } from "utils/nuberFormat";
import { sd } from "../tokens";
import PeriodDropdown from "./PeriodDropdown";

interface DashboardHeaderProps {
  name?: string;
  /** ออเดอร์ใหม่ที่รอจัดการ — ยอดสด ไม่ผูกกับช่วงเวลาที่เลือก */
  newOrderCount?: number;
  period: SellerReportPeriod;
  onPeriodChange: (period: SellerReportPeriod) => void;
}

const DashboardHeader = ({ name, newOrderCount, period, onPeriodChange }: DashboardHeaderProps) => (
  <Row justify="space-between" align="middle" gutter={[12, 12]}>
    <Col xs={24} md={15}>
      <Eyebrow>ภาพรวมร้านค้า</Eyebrow>
      <Greeting>สวัสดีครับ{name ? ` คุณ${name}` : ""}</Greeting>
      <SubText>
        {newOrderCount ? (
          <>
            วันนี้มี <Highlight>{numberFormatInt(newOrderCount)} ออเดอร์ใหม่</Highlight> ที่รอให้คุณจัดการ
          </>
        ) : (
          "วันนี้ยังไม่มีออเดอร์ใหม่ที่รอจัดการ"
        )}
      </SubText>
    </Col>
    <Col xs={24} md={9}>
      <TriggerWrapper>
        <PeriodDropdown period={period} onChange={onPeriodChange} />
      </TriggerWrapper>
    </Col>
  </Row>
);

export default DashboardHeader;

const Eyebrow = styled.div`
  font-size: 12px;
  color: ${sd.subtle};
  margin-bottom: 2px;
`;

const Greeting = styled.h1`
  margin: 0;
  font-size: 26px;
  line-height: 1.25;
  font-weight: 700;
  color: ${sd.navy};
`;

const SubText = styled.div`
  margin-top: 4px;
  font-size: 14px;
  color: ${sd.muted};
`;

const Highlight = styled.span`
  color: ${sd.orange};
  font-weight: 700;
`;

const TriggerWrapper = styled.div`
  display: flex;
  justify-content: flex-start;

  @media (min-width: 768px) {
    justify-content: flex-end;
  }
`;
